var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C13.5523 0 14 0.447715 14 1V10C14 10.5523 13.5523 11 13 11H12V14L9 11H1C0.447715 11 0 10.5523 0 10V1C0 0.447715 0.447715 0 1 0H13ZM13 1H1V10H9.5L11 11.5V10H13V1ZM8 7V8H3V7H8ZM11 5V6H3V5H11ZM11 3V4H3V3H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSingle);
export default __webpack_public_path__ + "static/media/message-single.6fb1f58f.svg";
export { ForwardRef as ReactComponent };